
import React, { PropTypes } from 'react';

import FA from 'react-fontawesome';

import Spacer from './Spacer';

const Repos = ({ repos }) => (
  <span>
    Repos:
    <span className="repos">
      {' '}
      {
        repos.map((repo, ix) => (
          <span key={ix}>
            <Spacer ix={ix} />
            <a
              href={repo.href}
              target="_blank"
              key={ix}
            >
              <FA name="github" />
              {' '}
              <span>{repo.text}</span>
            </a>
          </span>
        ))
      }
    </span>
  </span>
);

Repos.propTypes = {
  repos: PropTypes.array.isRequired
};

export default Repos;



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/Repos.js